export const gridOptions = {
  toolbarConfig: {
    zoom: true,
    custom: true,
    print: true,
    slots: {
      buttons: "AI_toolbar_buttons",
    },
  },
  printConfig: {},
  keepSource: true,
  resizable: true,
  border: true,
  stripe: true,
  highlightHoverRow: true,
  highlightCurrentRow: true,
  // showHeaderOverflow: true,
  // showOverflow: true,
  rowId: "id",
  height: "600",
  size: "small",
  columns: [],
  data: [],
//   treeConfig: {
//     lazy: true,
//     children: "children",
//     hasChild: "hasChildren",
//     // loadMethod: this.loadChildrenMethod,
//   },
  editConfig: {
    trigger: "dblclick",
    mode: "row",
    showIcon: false,
    // activeMethod: this.activeRowMethod,
    showStatus: true,
  },
  sortConfig: {
    trigger: "cell",
  },
};
